
import Vue from 'vue'
import { required } from 'vuelidate/lib/validators'
import createAccrual from '@/connectors/accruals/create-accrual'
import { IAccruals, ICreateAccruals } from '@/types/accruals'
import showPersonalAccount from '@/connectors/personal-accounts/show-personal-account'
import Loader from '@/components/Loader.vue'
import getPersonalAccountAccruals from '@/connectors/accruals/get-personal-account-accruals'
import updateAccrual from '@/connectors/accruals/update-accrual'

export default Vue.extend({
  name: 'CheckingAccountFormWizard',
  components: { Loader },
  data () {
    return {
      loader: false,
      personalAccount: '',
      hasAccrual: false,
      formData: {
        moid: Number(localStorage.getItem('moid')),
        personalAccountId: Number(localStorage.getItem('personalAccId')),
        balance: 0,
        amount: 0,
        amountDate: ''
      } as ICreateAccruals | IAccruals
    }
  },
  mounted () {
    this.showPersonalAccount()
  },
  methods: {
    showPersonalAccount () {
      this.loader = true
      showPersonalAccount(Number(localStorage.getItem('personalAccId')), Number(localStorage.getItem('moid')))
        .then(response => {
          this.loader = false
          console.log('showPerAcc', response)
          this.personalAccount = response.accountGlobalId
          this.getAccrual(response.houseId, Number(localStorage.getItem('personalAccId')))
        }).catch(e => {
          this.loader = false
          console.error(e.response)
          // @ts-ignore
          this.$showErrorToast(e.response.data.message)
        })
    },
    getAccrual (houseId, accountId) {
      this.loader = true
      getPersonalAccountAccruals(Number(localStorage.getItem('moid')), houseId, accountId)
        .then(res => {
          console.log('accruals', res)
          if (res.length) {
            this.formData = res[0]
            this.hasAccrual = true
          }
          this.loader = false
        }).catch(e => {
          this.loader = false
          console.error(e.response)
          // @ts-ignore
          this.$showErrorToast(e.response.data.message)
        })
    },
    submitForm () {
      if (this.hasAccrual) {
        this.updateAccrual()
      } else this.createAccrual()
    },
    createAccrual () {
      this.$v.$touch()
      if (this.$v.$error) {
        return
      }
      createAccrual(this.formData as ICreateAccruals)
        .then(res => {
          console.log('createAccrual', res)
          this.$router.push('/app/attach_modules_wizard')
        })
        .catch(e => {
          console.error(e.response)
          // @ts-ignore
          this.$showErrorToast(e.response.data.message)
        })
    },
    updateAccrual () {
      this.$v.$touch()
      if (this.$v.$error) {
        return
      }
      this.formData.moid = Number(localStorage.getItem('moid'))
      updateAccrual(this.formData.id as number, this.formData as IAccruals)
        .then(res => {
          console.log('updateAccrual', res)
          this.$router.push('/app/house_wizard')
        })
        .catch(e => {
          console.error(e.response)
          // @ts-ignore
          this.$showErrorToast(e.response.data.message)
        })
    }
  },
  validations: {
    formData: {
      balance: {
        required
      },
      amount: {
        required
      },
      amountDate: {
        required
      }
    }
  }
})
